module.exports = __webpack_public_path__ + "static/media/YellowGraphIcon.b6dc1e61.svg";